import { render, staticRenderFns } from "./form-user-simple.vue?vue&type=template&id=0a71745d&scoped=true&"
import script from "./form-user-simple.vue?vue&type=script&lang=js&"
export * from "./form-user-simple.vue?vue&type=script&lang=js&"
import style0 from "./form-user-simple.vue?vue&type=style&index=0&id=0a71745d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a71745d",
  null
  
)

export default component.exports